import { useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";

const AddAlertTypeModal = ({ open, onClose, onSave, editData }) => {
  const [form, setForm] = useState({
    alertTypeName: "",
  });

  useEffect(() => {
    if (open) {
      setForm({
        alertTypeName: editData?.alertTypeName || "",
      });
    } else {
      setForm({ alertTypeName: ""});
    }
  }, [open, editData]);

  if (!open) return null;

  return (
    <div className="admin-modal-overlay">
      <div className="admin-modal">
        <div className="admin-modal-header">
          <div className="admin-modal-title">
            {editData ? "Edit Alert Type" : "Add Alert Type"}
          </div>
          <button className="admin-modal-close" onClick={onClose}>
            <IoClose />
          </button>
        </div>

        <div className="admin-form-body">
          <label className="admin-label">Alert Type Name <span>*</span></label>
          <input
            className="admin-input"
            value={form.alertTypeName}
            onChange={(e) => setForm({ ...form, alertTypeName: e.target.value })}
            name="alertTypeName"
            placeholder="Enter Alert Type Name"
            required
          />
        </div>

        <div className="admin-form-footer">
          <button className="admin-btn-cancel" onClick={onClose}>
            CANCEL
          </button>
          <button className="admin-btn-save" disabled={!form.alertTypeName.trim()}
            onClick={() => onSave( form )}>
            SAVE
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddAlertTypeModal;
